module.exports = __webpack_public_path__ + "images/arrow.png?57f8d7f137f0ec60d56541353ece7870";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = OsgU
// module chunks = 0